import {FC, ReactNode} from 'react'
import styles from './BoxDouble.scss'

interface BoxProps {
  children?: ReactNode
}

export const BoxDouble: FC<BoxProps> = ({children}) => <div className={styles.double}>{children}</div>
